// src/components/modals/AddProductModal.jsx
import React, { useState, useEffect } from 'react';

const AddProductModal = ({ isOpen, onClose, onSave, brands }) => {
    
    const initialState = {
        name: '',
        brand: '',
        category: '',
        cost: '',
        salePrice: '',
        quantity: '',
        purchaseDate: new Date().toISOString().split('T')[0],
        expiry: '',
        code: ''
    };

    const [formState, setFormState] = useState(initialState);

    useEffect(() => {
        if (isOpen) {
            setFormState(initialState);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormState(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const newProduct = {
            ...formState,
            cost: parseFloat(formState.cost) || 0,
            salePrice: parseFloat(formState.salePrice) || 0,
            initialQty: parseInt(formState.quantity, 10) || 0,
            soldQty: 0,
            purchaseDate: new Date(`${formState.purchaseDate}T00:00:00`),
            expiry: new Date(`${formState.expiry}T00:00:00`),
        };

        try {
            await onSave(newProduct);
            onClose(); 
        } catch (error) {
            console.error("Erro ao adicionar produto:", error);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 w-full max-w-lg m-4 sm:m-8 max-h-[90vh] overflow-y-auto">
                <h2 className="text-2xl font-bold text-gray-800 mb-6">Adicionar Novo Produto</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label htmlFor="name" className="form-label">Nome do Produto</label>
                        <input id="name" name="name" value={formState.name} onChange={handleChange} type="text" placeholder="Ex: Base Líquida Matte" className="w-full px-4 py-2 border border-gray-300 rounded-lg" required />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label htmlFor="brand" className="form-label">Marca</label>
                            <select id="brand" name="brand" value={formState.brand} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg" required>
                                <option value="">Selecione...</option>
                                {brands.map(b => <option key={b.id} value={b.name}>{b.name}</option>)}
                            </select>
                        </div>
                        <div>
                            <label htmlFor="category" className="form-label">Categoria</label>
                            <input id="category" name="category" value={formState.category} onChange={handleChange} type="text" placeholder="Ex: Maquilhagem" className="w-full px-4 py-2 border border-gray-300 rounded-lg" required />
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label htmlFor="cost" className="form-label">Custo (R$)</label>
                            <input id="cost" name="cost" value={formState.cost} onChange={handleChange} type="number" step="0.01" placeholder="25,50" className="w-full px-4 py-2 border border-gray-300 rounded-lg" required />
                        </div>
                        <div>
                            <label htmlFor="salePrice" className="form-label">Preço de Venda (R$)</label>
                            <input id="salePrice" name="salePrice" value={formState.salePrice} onChange={handleChange} type="number" step="0.01" placeholder="49,90" className="w-full px-4 py-2 border border-gray-300 rounded-lg" required />
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div>
                            <label htmlFor="quantity" className="form-label">Quantidade Inicial</label>
                            <input id="quantity" name="quantity" value={formState.quantity} onChange={handleChange} type="number" placeholder="10" className="w-full px-4 py-2 border border-gray-300 rounded-lg" required />
                        </div>
                        <div>
                            <label htmlFor="purchaseDate" className="form-label">Data de Compra</label>
                            <input id="purchaseDate" name="purchaseDate" value={formState.purchaseDate} onChange={handleChange} type="date" className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-500" required />
                        </div>
                        <div>
                            <label htmlFor="expiry" className="form-label">Validade</label>
                            <input id="expiry" name="expiry" value={formState.expiry} onChange={handleChange} type="date" className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-500" required />
                        </div>
                    </div>
                     <div>
                        <label htmlFor="code" className="form-label">Código de Barras (Opcional)</label>
                        <input id="code" name="code" value={formState.code} onChange={handleChange} type="text" placeholder="Ex: 789002" className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
                    </div>
                    <div className="flex flex-col-reverse sm:flex-row justify-end gap-4 pt-4">
                        <button type="button" onClick={onClose} className="py-2 px-6 bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300">Cancelar</button>
                        <button type="submit" className="custom-button py-2 px-6 font-semibold rounded-lg">Salvar Produto</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddProductModal;